// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__pvoCa","alert":"SettungsInbox_alert__2tuwf"};